var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDexLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 16,
    viewBox: "0 0 29 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.59989 6.14238V1.94141H9.15469V13.8315H6.59989V13.0277C6.00682 13.7254 5.17041 14.059 4.06029 14.059C2.93497 14.059 1.97693 13.6344 1.18614 12.7699C0.395343 11.9054 0 10.8436 0 9.56988C0 8.31112 0.395379 7.2495 1.18614 6.38503C1.99214 5.50541 2.95018 5.08076 4.06029 5.08076C5.15521 5.09592 6.00682 5.44474 6.59989 6.14238ZM2.53959 9.58505C2.53959 10.222 2.72208 10.7225 3.10225 11.1016C3.48243 11.4808 3.96907 11.6628 4.56214 11.6628C5.15521 11.6628 5.65705 11.4808 6.02202 11.1016C6.4022 10.7225 6.58468 10.222 6.58468 9.58505C6.58468 8.94808 6.40238 8.4476 6.02202 8.06845C5.64167 7.6893 5.15521 7.50713 4.56214 7.50713C3.96907 7.50713 3.46723 7.68912 3.10225 8.06827C2.72208 8.4476 2.53959 8.94808 2.53959 9.58505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3587 10.601H13.3062C13.5951 11.3896 14.2643 11.7839 15.3439 11.7839C16.0435 11.7839 16.5757 11.5716 16.9863 11.1318L19.0241 12.2996C18.1877 13.4674 16.9559 14.0437 15.3135 14.0437C13.8992 14.0437 12.7435 13.619 11.8767 12.7697C11.0251 11.9204 10.5993 10.8437 10.5993 9.55455C10.5993 8.28061 11.0251 7.219 11.8614 6.35454C12.7132 5.49008 13.8081 5.06543 15.1312 5.06543C16.3629 5.06543 17.397 5.49008 18.2182 6.35454C19.0546 7.18866 19.4652 8.25028 19.4652 9.55455C19.4646 9.90606 19.4289 10.2566 19.3587 10.601ZM13.2607 8.70526H16.9255C16.6822 7.81047 16.0739 7.35549 15.1159 7.35549C14.1274 7.35549 13.5039 7.81029 13.2607 8.70526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4833 7.58294H27.4184L28.9999 5.33838H26.0649L24.4833 7.58294Z",
    fill: "#FC336F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8935 13.8313H25.9585L24.4833 11.7232L23.0084 13.8313H20.0733L23.0235 9.66068L19.9669 5.33838H22.902L24.4833 7.58294L25.9432 9.66068L28.8935 13.8313Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDexLogo);
export default __webpack_public_path__ + "static/media/DexLogo.d1cd5569c3f5b4bcc80b667700d18001.svg";
export { ForwardRef as ReactComponent };